// Vuex records module main file
import actions from './actions';
import mutations from './mutations';

const INITIAL_STATE = {
  list: {
    page: 1,
    records: [],
    total: 0,
  },
  activeCampaign: {},
};

const getters = {
  list: state => state.list,
  activeCampaign: state => state.activeCampaign
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
const Module = {
  namespaced: true,
  state: INITIAL_STATE,
  mutations,
  actions,
  getters,
};

export default Module;
